module.exports = __webpack_public_path__ + "img/st-icon-1.9032a8bc.png";